
import {
    STATES_ATTEMPT,
    STATES_SUCCESS,
    STATES_FAILED,
} from '../types/stateTypes';

const INITIAL_STATE = {
    loading: false,
    list: [],
    error: '',
};
function state(state = INITIAL_STATE, action) {
    switch (action.type) {
        case STATES_ATTEMPT:
            return {
                ...state,
                loading: true,
            }

        case STATES_SUCCESS:
            return {
                ...state,
                loading: false,
                list: action.data.list,
                error: ''
            }

        case STATES_FAILED:
            return {
                ...state,
                loading: false,
                error: action.error,
                list: []
            }
        default: return state;
    }
};
export default state;